module.exports = __webpack_public_path__ + "static/media/popup.d61ab8d4.svg";